import { render } from "./Gallery.vue?vue&type=template&id=663eaaad&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=663eaaad&scoped=true&lang=scss"

import exportComponent from "/Users/alexanderwesselburg/Projekte/MyPortal/fewo-in-ahrenshoop_v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663eaaad"]])

export default __exports__